import React from 'react';
import { Box } from '@material-ui/core';

import { ArrowRight, ArrowLeft } from '@material-ui/icons';
import { useTheme, useMediaQuery } from '@material-ui/core';
import {
  MOBILE_MENU_COLLAPSED_HEIGHT,
  MOBILE_MENU_SAFE_GAP
} from 'src/app/constant/mapLayout';

export const ButtonShowMenuTracking = ({ showMenu, setShowMenu }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box
      style={{
        position: 'fixed',
        top: isMobile ? 76 : 90,
        left: isMobile
          ? showMenu
            ? 'calc(100% - 30px)'
            : '0'
          : showMenu
          ? '384px'
          : '0px',
        backgroundColor: 'white',
        zIndex: isMobile ? 999 : 450,
        cursor: 'pointer',
        boxShadow: '0 1px 1px rgba(0,0,0,0.2)',
        borderRadius: isMobile ? '8px 0 0 8px' : '0 8px 8px 0',
        width: '28px',
        height: isMobile ? '36px' : '48px',
        display: showMenu ? 'block' : 'none',
        transition: 'left 0.3s ease'
      }}
    >
      <Box
        title="Ẩn Menu"
        onClick={() => setShowMenu(false)}
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          transition: 'all 0.3s ease-in'
        }}
      >
        <ArrowLeft />
      </Box>
    </Box>
  );
};

export const ButtonHideMenuTracking = ({ showMenu, setShowMenu }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box
  style={{
    position: 'absolute',
    top: '22px',
    left: '0px',
    backgroundColor: 'white',
    zIndex: isMobile ? 999 : 450,
    cursor: 'pointer',
    boxShadow: '0 1px 1px rgba(0,0,0,0.2)',
    borderRadius: '0 8px 8px 0',
    width: '28px',
    height: isMobile ? '36px' : '48px',
    display: showMenu ? 'none' : 'block'
  }}
>

      <Box
        title="Hiện Menu"
        onClick={() => setShowMenu(true)}
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          transition: 'all 0.3s ease-in'
        }}
      >
        <ArrowRight />
      </Box>
    </Box>
  );
};

export const ButtonGetCurrentLocation = ({
  getLocation,
  variant = 'tracking'
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const bottomOffset =
    variant === 'routing'
      ? 76
      : isMobile
      ? MOBILE_MENU_COLLAPSED_HEIGHT + MOBILE_MENU_SAFE_GAP
      : 80;

  return (
    <Box
      className={`get_current_location ${variant}`}
      style={{
        position: 'absolute',
        bottom: `${bottomOffset}px`,
        right: '20px',
        zIndex: 1000
      }}
      onClick={getLocation}
    >
      <img src="/static/iconSvg/locationIconv2.svg" alt="location" />
    </Box>
  );
};
